/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'jwt-match';
const prefix = `${moduleName}.${componentName}`;

export const tokenNameLabel = `${prefix}.tokenNameLabel`;
export const tokenNamePlaceholder = `${prefix}.tokenNamePlaceholder`;
export const addClaimNameButtonLabel = `${prefix}.addClaimNameButtonLabel`;

export const ENGLISH = {
    [tokenNameLabel]: 'Token Name',
    [tokenNamePlaceholder]: 'Enter Token Name',
    [addClaimNameButtonLabel]: 'Add Claim Name',
};
